import { render, staticRenderFns } from "./FeeDetailFeeObj.vue?vue&type=template&id=7d36c567&scoped=true"
import script from "./FeeDetailFeeObj.vue?vue&type=script&lang=js"
export * from "./FeeDetailFeeObj.vue?vue&type=script&lang=js"
import style0 from "./FeeDetailFeeObj.vue?vue&type=style&index=0&id=7d36c567&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d36c567",
  null
  
)

export default component.exports